<template>
  <header class="l-header blur" id="header">
    <nav class="nav bd-grid">
      <div>
        <button @click="linkLogo" class="nav__logo">
          <span class="one__name">loïc</span
          ><span class="two__name">farel</span>
        </button>
      </div>
      <div></div>
    </nav>
  </header>
</template>

<script>
import router from "@/router";
export default {
  data() {
    return {
      nav: false,
      bascule: false,
      light__theme: "light-theme",
      theme: "light",
    };
  },

  methods: {
    addShow() {
      document.querySelector(".nav__menu").classList.add("show");
      document.querySelector(".l-header").classList.remove("blur");
      document.querySelector(".nav__menu-right").classList.add("show-right");
    },

    removeShow() {
      document.querySelector(".nav__menu").classList.remove("show");
      document.querySelector(".l-header").classList.add("blur");
      document.querySelector(".nav__menu-right").classList.remove("show-right");
    },

    showNav() {
      this.nav = true;
      this.addShow();
    },

    maskNav() {
      this.removeShow();
      this.nav = false;
      // this.playSong(this.lumineux);
    },

    linkLogo() {
      router.push("/");
    },

    // Mode Clair et Sombre Button

    setTheme() {
      localStorage.setItem("theme", this.theme);
    },

    modeLight() {
      // this.playSong(this.lumineux);
      this.bascule = true;
      document.body.classList.add(this.light__theme);
      this.theme = "light";
      this.setTheme();
    },

    modeSombre() {
      // this.playSong(this.sombre);
      this.bascule = true;
      document.body.classList.add(this.light__theme);
      this.theme = "light";
      this.setTheme();
    },

    playSong(src) {
      this.player.load();
      this.player.src = src;
      this.player.play();
    },

    getTheme() {
      this.theme = "light";
    },

    ModeButton() {
      this.getTheme();

      document.body.classList.add(this.light__theme);
    },
  },

  mounted() {
    this.ModeButton();
  },
};
</script>

<style scoped>
.l-header {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  overflow: hidden;
  background: var(--body-color-1);
}

.blur {
  backdrop-filter: blur(5px);
  background: var(--body-color);
}

.bd-grid {
  /* max-width: 1200px;
  margin: 0 1rem; */
  width: 100%;
  padding: 1rem;
}

.nav {
  height: var(--header-height);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav .nav__toggle {
  cursor: pointer;
}

.nav__logo {
  font-family: "sacramento";
  cursor: pointer;
}

.one__name,
.two__name {
  font-size: 35px;
  font-weight: 600;
}

.one__name {
  color: var(--first-color);
}

.two__name {
  color: var(--title-color);
}

.nav__menu-right {
  display: none;
}

@media screen and (max-width: 968px) {
  .nav__menu {
    position: fixed;
    right: -150%;
    top: var(--header-height);
    background: var(--body-color);
    width: 70%;
    height: 100%;
    border-top: 1px solid var(--nav-boder);
    padding: 2rem;
    z-index: 100;
    transition: 0.4s;
  }

  .nav__menu-right {
    display: block;
    position: fixed;
    left: -150%;
    top: var(--header-height);
    background: rgba(0, 0, 0, 0.2);
    width: 30%;
    height: 100%;
    z-index: 100;
    transition: 0.4s;
  }

  .nav__link svg {
    margin-right: 1rem;
  }

  /* Lien de la page active */
  .nav__list .nav__item a.router-link-exact-active {
    display: block;
    border-right: 5px solid var(--first-color-alt);
    border-radius: 0.2rem;
  }

  a.router-link-exact-active svg {
    fill: var(--first-color-alt);
  }
}

.nav__menu .nav__list {
  display: flex;
  flex-direction: column;
  row-gap: 2.5rem;
}

.nav__list .nav__item {
  font-size: 1.25rem;
  font-weight: var(--font-medium);
}

.nav__item .nav__link {
  padding: 0.25rem 0;
  color: var(--first-color);
}

.nav svg {
  fill: var(--first-color);
  cursor: pointer;
}

/* Show menu */
.show {
  right: 0;
  background: var(--body-color-1);
}

.show-right {
  left: 0;
}

@media screen and (min-width: 968px) {
  .bd-grid {
    padding: 0 2rem;
  }

  .nav__link svg {
    display: none;
  }

  .nav__item .nav__link::after {
    display: block;
    content: "";
    border-bottom: 2px solid var(--first-color);
    transform: scaleX(0);
    transition: transform 0.25s ease-in-out;
  }

  .nav__item .nav__link:hover::after {
    color: var(--first-color-alt);
    transform: scaleX(1);
  }

  a.router-link-exact-active {
    border-bottom: 2px solid var(--first-color-alt);
  }

  a.router-link-exact-active:hover {
    border: 0;
  }

  .nav {
    height: calc(var(--header-height) + 0.25rem);
  }

  .nav .nav__toggle {
    display: none;
  }

  .nav__menu .nav__list {
    flex-direction: row;
    column-gap: 3rem;
  }
}

button {
  outline: none;
  background: transparent;
}
</style>
